import { Button, Pagination } from '@heroui/react'

export default function PaginationComponent({
  total,
  page,
  onPageChange,
}: {
  total: number
  page: number
  onPageChange: (page: number) => void
}) {
  // Ensure we have valid values
  const safeTotal = Math.max(1, total || 1)
  const safePage = Math.max(1, Math.min(page || 1, safeTotal))

  const isFirstPage = safePage <= 1
  const isLastPage = safePage >= safeTotal

  return (
    <div className="flex gap-2 items-center">
      <Button
        isIconOnly
        className="w-[32px] rounded min-w-[32px] h-[32px] border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 disabled:border-gray-200 dark:disabled:border-gray-700 disabled:bg-gray-100 dark:disabled:bg-gray-700 disabled:opacity-50 disabled:cursor-not-allowed disabled:text-gray-400 dark:disabled:text-gray-500"
        isDisabled={isFirstPage}
        onPress={() => onPageChange(safePage > 1 ? safePage - 1 : safePage)}
      >
        <svg
          className="w-4 h-4 rotate-90"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="m19.92 8.95-6.52 6.52c-.77.77-2.03.77-2.8 0L4.08 8.95"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
          />
        </svg>
      </Button>
      <Pagination
        page={safePage}
        total={safeTotal}
        classNames={{
          wrapper: 'gap-2 overflow-visible h-8 rounded ',
          item: 'w-[32px] h-[32px] text-small rounded bg-transparent border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300',
          cursor:
            'bg-transparent !h-full border border-blue-500 dark:border-blue-400 rounded text-blue-600 dark:text-blue-400 font-bold',
        }}
        onChange={onPageChange}
      />

      <Button
        isIconOnly
        className="w-[32px] min-w-[32px] rounded h-[32px] border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 disabled:border-gray-200 dark:disabled:border-gray-700 disabled:bg-gray-100 dark:disabled:bg-gray-700 disabled:opacity-50 disabled:cursor-not-allowed disabled:text-gray-400 dark:disabled:text-gray-500"
        isDisabled={isLastPage}
        onPress={() => onPageChange(safePage < safeTotal ? safePage + 1 : safePage)}
      >
        <svg
          className="w-4 h-4 -rotate-90"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="m19.92 8.95-6.52 6.52c-.77.77-2.03.77-2.8 0L4.08 8.95"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
          />
        </svg>
      </Button>
    </div>
  )
}
